define(
    'views/reports.view',[
        'loader',
        'config',
        'helper',
        'sandbox',

        'text!templates/reports_button.html',
        'text!templates/reports.html'
    ],
    function(Loader, Config, Helper, Sandbox, reportsButtonTemplate, reportsTemplate)
    {
        var $ = Loader.$;
        var _ = Loader._;

        var ForumDescriptionView = Loader.Backbone.View.extend(
            {

                postId: 0,

                events: Helper.prepareEventsForDevice(
                    {
                        'click li.pl-reports a': 'showForm',
                        'click #reportButtonSend': 'sendReport',
                        'click .post_report.bg': 'hideForm',
                        'click #reportButtonCancel': 'hideForm'
                    },
                    Loader.eventType
                ),

                routes: {
                    "/viewtopic.php": "prepareReportsButtons prepareReportsForm"
                },

                initialize: function()
                {
                    var _this = this;
                    _.bindAll(this, 'render');
                    var user =  this.model.get('users').getMe();

                    this.model.on('startApplication', function(){
                        if (Config.modules.reports.enabled)
                            Helper.filterRoutes(_this.routes, _this);
                    });
                },

                render: function()
                {
                    if (Config.modules.reports.enabled == false) return this;

                    var elem = $("#pun-report");

                    var compiledTemplate = _.template(
                        reportsTemplate,
                        {
                            model: this.model.toJSON()
                        }
                    );

                    elem.html(compiledTemplate);
                    return this;
                },

                prepareReportsForm: function()
                {
                    var _this = this;

                    var elem = $("div.linksb");
                    elem.after('<div id="pun-report"></div>');
                    this.render();
                },

                prepareReportsButtons: function()
                {
                    var a = document.getElementsByTagName("a");
                    var mass = [];
                    var m=0;

                    for( q = 0; q < a.length; q++ ) {
                        if(	a[q].className == "permalink" ) {
                            mass.push(a[q].href.substring(a[q].href.indexOf("#p")+2));
                        }
                    }

                    var compiledTemplate = "";
                    var li = document.getElementsByTagName("li");
                    for( i=0; i < li.length; i++ ) {
                        if(li[i].className=="pl-quote"){
                            compiledTemplate = _.template(
                                reportsButtonTemplate,
                                {
                                    model: this.model.toJSON(),
                                    postId: mass[m]
                                }
                            );
                            li[i].parentNode.innerHTML+=compiledTemplate;
                            m++;
                        }
                    }
                },

                showForm: function(e)
                {
                    e && e.preventDefault();
                    this.postId = $(e.currentTarget).attr('data-post-id');
                    $('div.post_report').fadeIn('fast');
                },

                hideForm: function(e)
                {
                    e && e.preventDefault();
                    $('div.post_report').fadeOut('fast');
                },

                sendReport: function(e)
                {
                    var _this = this;
                    var text = $('#rep_text').val();
                    var $button = $(e.currentTarget);

                    e.preventDefault();
                    if (text.length == 0){
                        alert('Вы должны указать причину жалобы.');
                        return;
                    }

                    $button.attr('disabled', true);
                    $button.val('Отправляю...');

                    this.model.get('forum').sendReport({
                        text: text,
                        postId: _this.postId,
                        topicId: window['FORUM'].get('topic.subject'),
                        topicSubject: window['FORUM'].get('topic.subject')
                    }, function(){
                        alert('Сообщение отправлено! Спасибо за уведомление!');
                        _this.hideForm(e);
                        $('#rep_text').val('');
                        $button.attr('disabled', false);
                        $button.val('Отправить');
                    }, function(){
                        alert('Произошла ошибка при сохранении описания');
                        _this.hideForm(e);
                        $button.attr('disabled', false);
                        $button.val('Отправить');
                    });
                }
            });

        return {
            initialize: function(model)
            {
                return new ForumDescriptionView({
                    el: $("#pun-main"),
                    model: model
                })
            }
        }
    }
);
